<div class="main-wrapper">
  <div class="header-wrapper">
    <label class="header-active">Notes</label>
    <button class="new-note-btn" (click)="addNewNote()">
      <span class="plus-icon">+</span> New Note
    </button>
  </div>
  
  <!-- New Note Input Section -->
  <div class="new-note-input-wrapper" *ngIf="showNewNoteInput">
    <textarea 
      class="new-note-textarea"
      [(ngModel)]="newNoteText"
      placeholder="Enter your note here..."
      (blur)="onBlurSaveNote()"
      (keydown.enter)="onEnterSaveNote($event)"
      (keydown.escape)="cancelNewNote()"
      [disabled]="isSavingNote"
      autofocus>
    </textarea>
    <div class="new-note-hint">
      <span *ngIf="!isSavingNote">Press Enter to save, Esc to cancel, or click outside to save</span>
      <span *ngIf="isSavingNote">Saving...</span>
    </div>
  </div>
  
  <div class="no-notes" *ngIf="noteCollection.length == 0 && !showNewNoteInput">
    <span>No notes found.</span>
  </div>
  <div class="notes-container">
    <ul>
      <li *ngFor="let n of noteCollection">
        <div class="note-item-wrapper">
          <img
            [src]="base64Sanitize(n.IM)"
            alt="Image Source"
            (click)="showPopup(base64Sanitize(n.IM))"
          />

          <div class="noteInfo">
            <div class="time">
              {{ n.T | date : "M/d/yy, h:mm:ss a" }}
            </div>
            <div class="text">
              {{ n.TX }}
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>

  <div class="popup" *ngIf="showImagePopup">
    <img
      [src]="selectedImage"
      style="width: 800px; height: 400px"
      alt="Skaret View"
    />
    <a [routerLink]="" class="closeBtn" (click)="closePopup()">X</a>
  </div>
</div>
